import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=410ab959&scoped=true"
import script from "./Buscador.vue?vue&type=script&lang=js"
export * from "./Buscador.vue?vue&type=script&lang=js"
import style0 from "./Buscador.vue?vue&type=style&index=0&id=410ab959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410ab959",
  null
  
)

export default component.exports